import type React from "react";
import {Outlet} from "react-router";
import {Box} from "@mui/system";
import {SimpleEnvWrapper} from "~/jobs/wrapper/SimpleEnvWrapper";
import {DRAWER_HEADER_HEIGHT_LG} from "~/components/main/drawer/DrawerConstants.ts";

/** Wrapper for the v2 taxonomy approval review: no dataset needed, like the current approval pages. */
export const TaxonomyApprovalLayout: React.FC = () => (
    <SimpleEnvWrapper state={{fluid: true, dataType: 'no_data', appSection: 'approval'}}>
        {/* The page sits in a flex row: without a full width, the box could take the table's width. */}
        <Box sx={{width: '100%', minWidth: 0, height: `calc(100vh - ${DRAWER_HEADER_HEIGHT_LG}px)`, overflow: 'auto', position: 'relative'}}>
            <Outlet/>
        </Box>
    </SimpleEnvWrapper>
);
